module.exports = __webpack_public_path__ + "img/live.42e7fb5.png";